import { HttpClient } from '@wix/sdk-types';
import {
  ChannelWithLiterals,
  NotifyOptions,
  notify as universalNotify,
} from './ping-notifications-v1-public-notification-notifications.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/notifications' };

export function notify(httpClient: HttpClient): NotifySignature {
  return (
    body: string,
    channels: ChannelWithLiterals[],
    options?: NotifyOptions
  ) =>
    universalNotify(
      body,
      channels,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface NotifySignature {
  /**
   * Sends a notification.
   *
   *
   * The `notify()` function sends a [notification](https://support.wix.com/en/article/about-your-dashboard-notifications) to the specified recipients on the specified channels.
   *
   * List the the channels for the notification in the `channels` parameter .
   *
   * List the recipients for the notification in the `toContacts`, `toSiteContributors`, and `toTopicsSubscribers` parameters.
   * @param - Notification options.
   * @param - Body of the notification. This contains the main content of the notification.
   * @param - Channel through which users receive the notification.
   * - `"Mobile"`: Sends the notification to the Wix App.
   * - `"Dashboard"`: Sends the notification to the collaborator's Wix Dashboard.
   * - `"Browser"`: Sends the notification to the collaborator's browser.
   * @returns Fulfilled when the send notification request is received.
   */
  (
    body: string,
    channels: ChannelWithLiterals[],
    options?: NotifyOptions
  ): Promise<void>;
}

export {
  Channel,
  DashboardPages,
  Empty,
  NotifyOptions,
  NotifyOptionsActionTargetOneOf,
  NotifyOptionsRecipientsFilterOneOf,
  PublicNotifyRequest,
  PublicNotifyRequestActionTargetOneOf,
  PublicNotifyRequestRecipientsFilterOneOf,
  Public_notification,
  Role,
  ToContacts,
  ToSiteContributors,
  ToTopicsSubscribers,
} from './ping-notifications-v1-public-notification-notifications.universal.js';
